import React from "react";  
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HomeLayout from "./Pages/Home";
import AboutLayout from "./Pages/About";
import ContactLayout from "./Pages/Contact";
import Portfolio from "./Pages/Portfolio";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeLayout />} />
        <Route path="/about" element={<AboutLayout />} />
        <Route path="/contact" element={<ContactLayout />} />
        <Route path="/portfolio" element={<Portfolio />} />

      </Routes>
    </Router>
  );
}

export default App;
